import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-sac-form',
  templateUrl: './sac-form.component.html',
  styleUrls: ['./sac-form.component.css']
})
export class SacFormComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public processando: boolean;
  public chamado: any;
  public mensagem: string;
  public assunto: string;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    this.mensagem = undefined;
    this.assunto = undefined;
    this.processando = false;
    const anexo = { arquivo: undefined, nome: undefined, tipo: undefined };
    this.chamado = { assunto: '', mensagens: [{ mensagem: '' }], anexos: [anexo, anexo, anexo] };
    this.mainService.saldoService.initialize();
  }

  public saveChamado() {
    this.processando = true;

    const url = 'cartao/current/chamado/';
    const chamadoEnviado = this.chamado;
    if (this.chamado.anexos[0].arquivo == undefined
      && this.chamado.anexos[1].arquivo == undefined
      && this.chamado.anexos[2].arquivo == undefined) {
      chamadoEnviado.anexos = [];
    } else if (this.chamado.anexos[0].arquivo !== undefined
      && this.chamado.anexos[1].arquivo == undefined
      && this.chamado.anexos[2].arquivo == undefined) {
      chamadoEnviado.anexos = [this.chamado.anexos[0]];
    } else if (this.chamado.anexos[0].arquivo !== undefined
      && this.chamado.anexos[1].arquivo !== undefined
      && this.chamado.anexos[2].arquivo == undefined) {
      chamadoEnviado.anexos = [this.chamado.anexos[0], this.chamado.anexos[1]];
    }
    this.mainService.http.pathRest().post(url, chamadoEnviado, true)
      .subscribe(
        sucesso => {
          this.processando = false;
          this.router.navigate(['/sac']);
        }, error => {
          this.processando = false;
          this.bootboxAlertComId.alerta(error._body);
        });
  }

  public formatFile(event, item) {
    try {
      const file: File = event.target.files[0];
      const reader: FileReader = new FileReader();
      let retorno;
      reader.onload = (valor) => {
        retorno = { 'arquivo': reader.result.split(',')[1], 'tipo': file.type, 'nome': file.name };
        if (item === 0) {
          this.chamado.anexos[0] = retorno;
          const e: HTMLInputElement = <HTMLInputElement>document.getElementById('anexo1-hidden');
          e.value = retorno.nome;
        } else if (item === 1) {
          this.chamado.anexos[1] = retorno;
          const e: HTMLInputElement = <HTMLInputElement>document.getElementById('anexo2-hidden');
          e.value = retorno.nome;
        } else if (item === 2) {
          this.chamado.anexos[2] = retorno;
          const e: HTMLInputElement = <HTMLInputElement>document.getElementById('anexo3-hidden');
          e.value = retorno.nome;
        }
      };
      reader.readAsDataURL(file);
    } catch (e) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/form/sac-form.component.ts